import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Router from './router';

ReactDOM.render(<Router />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js